export default __webpack_public_path__ + "static/media/tecgeplog.a547991a.png";